(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Left-Right-Image-Slider"] && !window.DesignMode) return;
  try {
    
     $(document).ready(function() {
    $('.slider-container').each(function() {
      var container = $(this);
      var handle = container.find('.slider-handle');
      var arrows = container.find('.symbols');
      var foreground = container.find('.slider-image--foreground');
      var background = container.find('.slider-image--background');
      var drag = false;

      function updateHeight() {
        var foregroundHeight = foreground.height();
        container.css('height', foregroundHeight);
      }

      // Adjust the visibility of the images based on the handle position
      function updateImages() {
        var handlePositionPercent = handle.position().left / $(window).width();
        var arrowPositionPercent = arrows.position().left / $(window).width();
        var foregroundWidth = Math.round(container.width() * handlePositionPercent);
        var backgroundWidth = container.width() - foregroundWidth;

        handle.css('left', handlePositionPercent * 100 + '%');
        arrows.css('left', arrowPositionPercent * 100 + '%');
        foreground.css('clip', 'rect(0, ' + foregroundWidth + 'px, auto, 0)');
        background.css('clip', 'rect(0, auto, auto, ' + foregroundWidth + 'px)');
      }

      // Event listener for handle drag
      handle.on('mousedown touchstart', function(e) {
        e.preventDefault();
        drag = true;
      });

      $(document).on('mouseup touchend', function() {
        drag = false;
      });

      container.on('mousemove touchmove', function(e) {
        if (drag) {
          var xPosition = e.pageX || e.originalEvent.touches[0].pageX;
          var containerOffset = container.offset().left;
          var handlePosition = xPosition - containerOffset - (handle.width() / 2);
          var arrowPosition = xPosition - containerOffset - (arrows.width() / 2);
          var minPosition = 0;
          var maxPosition = container.width() - handle.width();
          var arrowMaxPosition = container.width() - arrows.width();

          handlePosition = Math.max(minPosition, Math.min(maxPosition, handlePosition));
          arrowPosition = Math.max(minPosition, Math.min(arrowMaxPosition, arrowPosition));
          handle.css('left', handlePosition + 'px');
          arrows.css('left', arrowPosition + 'px');
          updateImages();
        }
      });

      // Initialize the images and container height
      updateImages();
      updateHeight();

      // Adjust slider dimensions on window resize
      $(window).resize(function() {
        var handlePositionPercent = handle.position().left / $(window).width();
        updateImages();
        updateHeight();

        // Calculate the maximum handle position
        var maxHandlePosition = $(window).width() - handle.width();

        // Calculate the minimum handle position
        var minHandlePosition = 0;

        // Calculate the handle position based on the percentage
        var clampedHandlePosition = Math.max(Math.min(handlePositionPercent * $(window).width(), maxHandlePosition), minHandlePosition);

        handle.css('left', clampedHandlePosition + 'px');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
